import { defineComponent as u, computed as o, defineAsyncComponent as c } from "vue";
import { getEnergyEfficiencyProduct as d } from "@i22/rocket";
import { getConfig as f } from "./td-longtail-vue-components2.js";
import m from "./td-longtail-vue-components50.js";
import g from "./td-longtail-vue-components49.js";
const M = /* @__PURE__ */ u({
  __name: "energy-label",
  props: {
    energyClass: { default: void 0 },
    product: { default: void 0 },
    alignment: { default: "default" },
    noDataSheet: { type: Boolean },
    isInternalLink: { type: Boolean },
    reverse: { type: Boolean },
    isNotClickable: { type: Boolean }
  },
  emits: ["click", "open-document"],
  setup(l, { expose: a }) {
    const e = l, s = o(() => ["bottom", "left"].includes(e.alignment) ? "left" : "right"), i = o(() => ({
      [`energy-label--${e.alignment}`]: !0,
      "energy-label--reverse": e.reverse
    })), n = o(() => {
      if (e?.product)
        return d(e.product);
    }), p = o(() => {
      if (e.energyClass) return e.energyClass;
      if (n.value?.class) return n.value?.class;
    }), t = () => {
      if (!n.value) return;
      const r = f().globalModal || void 0;
      r?.openModal && r.openModal({
        component: {
          is: c(() => import("./td-longtail-vue-components51.js")),
          props: {
            energyLabel: n.value
          }
        }
      });
    };
    return a({ openEnergyModal: t }), { __sfc: !0, props: e, alignDropdown: s, containerClass: i, energyLabel: n, energyClassName: p, openEnergyModal: t, Icon: m, Datasheet: g };
  }
});
export {
  M as default
};
